import './update-credentials.css'
import * as React from 'react'
import CredentialsForm from '../../components/credentials-form/credentials-form'

/**
 * Update Credentials Component.
 * Represents the update credentials page.
 *
 * @returns {React.ReactElement} - Update Credentials Component.
 */
const UpdateCredentials = () => {
  return (
<CredentialsForm />
  )
}

export default UpdateCredentials
